import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  th: {
    "取消": 'ยกเลิก',
    "确定": 'ยืนยัน',
    "发送": 'ส่ง',
    "系统通知": 'การแจ้งเตือนของระบบ',
    "关闭": 'ปิด',
    "图片": 'รูปภาพ',
    "文件": 'ไฟล์',
    "表情": 'อีโมจิ',
    "视频": 'วิดีโอ',
    "录制": 'บันทึกวิดีโอ',
    "拍照": 'ถ่ายรูป',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;